module.exports = __webpack_public_path__ + "img/icon-auto-registration1.3d163ebb.svg";